module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre4"
  }, [_vm._v("Blätterfall")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Er kommt heran mit leisem Schritte"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nin stiller Nacht"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund hat umreift so Baum als Hütte,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\neh du erwacht.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Du öffnest deiner Pforte Riegel"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund trittst hinaus,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nReifsilber blinkt um Wald und Hügel"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund um dein Haus.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Noch stehen dicht belaubt die Bäume."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nO still, o still,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nwer nicht die letzten Frühlingsträume"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nverscheuchen will.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Von Blatt zu Blatte tönt hinüber"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nein trübes Wort:"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nDer Lenz, das Leben ist vorüber,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nwir müssen fort!")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Und ach, die Sonne, die sonst immer"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndas Licht gebracht,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nsie bringt mit ihrem goldnen Schimmer"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nuns heut die Nacht.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre1 pcalibre2",
    attrs: {
      "id": "page23",
      "title": "wedi/Konmax"
    }
  }), _vm._v(" Da steigt sie eben durch die Föhren"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nam Waldessaum,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nschon fallen leise Silberzähren"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nvon Strauch und Baum.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("O halte deine güldnen Sohlen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\no bleibe stehn,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndaß wir noch einmal Atem holen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund dann vergehn.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Doch wie die Blätter alle klagen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nsie hört es nicht"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund hebt wie sonst den güldnen Wagen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund spendet Licht.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Sie kommt mit heißen Flammenbächen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nso hell, so rot,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nsie will des Winters Siegel brechen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund bringt den Tod.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Da klingt die alte Wehmutsweise"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndurchs weite All,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund in die Laute raschelt leise"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nder Blätterfall. "), _c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre1 pcalibre2",
    attrs: {
      "id": "page24",
      "title": "Wunibald/wedi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a58ec006","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0008.vue
// module id = 78
// module chunks = 0